/** A trip field an update may change. The values are the API's field-mask paths. */
export var TripField;
(function (TripField) {
    TripField["TITLE"] = "title";
    TripField["ABOUT"] = "about";
})(TripField || (TripField = {}));
//# sourceMappingURL=TripField.js.map